import { gql } from '@apollo/client';

const EDIT_PHYSICIAN_NOTE_MUTATION = gql`
  mutation editPhysicianNote($studyFid: Int!, $note: String!, $signature: String) {
    editPhysicianNote(studyFid: $studyFid, note: $note, signature: $signature) {
      isSuccess
      message
    }
  }
`;

export default EDIT_PHYSICIAN_NOTE_MUTATION;
